import React, { useState, useEffect } from 'react';
import apiClient from '../../services/api';
import { API_ENDPOINTS } from '../../config/api';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import './Settings.css';

const Settings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [settings, setSettings] = useState({
    teacher_base_rate: 1200,
    teacher_threshold_children: 4,
    teacher_bonus_per_child: 100,
    teacher_help_rate: '',
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(API_ENDPOINTS.SETTINGS_SALARY);
      if (response.data.ok) {
        const responseData = response.data.data;
        const data = Array.isArray(responseData?.items)
          ? Object.fromEntries(responseData.items.map(item => [item.key, item]))
          : responseData || {};
        setSettings({
          teacher_base_rate: data.teacher_base_rate?.value_int ?? 1200,
          teacher_threshold_children: data.teacher_threshold_children?.value_int ?? 4,
          teacher_bonus_per_child: data.teacher_bonus_per_child?.value_int ?? 100,
          teacher_help_rate: data.teacher_help_rate?.value_int ?? '',
        });
      }
    } catch (error) {
      console.error('Ошибка загрузки настроек:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...settings };
      if (payload.teacher_help_rate === '') delete payload.teacher_help_rate;
      await apiClient.put(API_ENDPOINTS.SETTINGS_SALARY, payload);
      alert('Настройки сохранены');
    } catch (error) {
      alert('Ошибка сохранения настроек');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="settings-loading">Загрузка настроек...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="settings-page">
        <div className="settings-header">
          <div><h1 className="settings-title">Настройки</h1><p className="page-description">Общие параметры работы клуба</p></div>
        </div>

        <Card title="Настройки расчёта зарплаты">
          <form onSubmit={handleSave} className="settings-form">
            <Input
              type="number"
              label="Базовая ставка за занятие (₽)"
              value={settings.teacher_base_rate}
              onChange={(e) => setSettings({ ...settings, teacher_base_rate: parseInt(e.target.value) })}
              min="0"
              required
            />

            <Input
              type="number"
              label="Порог детей для доплаты"
              value={settings.teacher_threshold_children}
              onChange={(e) => setSettings({ ...settings, teacher_threshold_children: parseInt(e.target.value) })}
              min="0"
              required
            />

            <Input
              type="number"
              label="Доплата за каждого ребёнка после порога (₽)"
              value={settings.teacher_bonus_per_child}
              onChange={(e) => setSettings({ ...settings, teacher_bonus_per_child: parseInt(e.target.value) })}
              min="0"
              required
            />

            <Input
              type="number"
              label="Стоимость помощи (₽)"
              value={settings.teacher_help_rate}
              onChange={(e) => setSettings({ ...settings, teacher_help_rate: e.target.value === '' ? '' : Number(e.target.value) })}
              min="0"
              step="1"
              placeholder="Укажите стоимость помощи"
            />
            <p className="form-hint">Стоимость фиксируется в каждой новой записи «Помощь». Уже внесённые записи сохраняют прежнюю стоимость. Пока стоимость не задана, помощь добавить нельзя.</p>

            <div className="form-actions">
              <Button type="submit" variant="primary" disabled={saving}>
                {saving ? 'Сохранение...' : 'Сохранить'}
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </Layout>
  );
};

export default Settings;
